import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Partner.css';

const TILES = [
  {
    title: 'Deal Registration',
    description: 'Register new deals and track pipeline opportunities.',
    icon: '📋',
    path: '/partner/deals/new',
  },
];

const PartnerDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = location.state?.user;
  const dealRegistered = location.state?.dealRegistered;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="main-hero demo-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">Partner Portal</h1>
      </section>

      <section className="ptn-content">
        {dealRegistered ? (
          <p className="ptn-dashboard-deal-success">
            Your deal is registered with Bltz AI!
          </p>
        ) : user && (
          <p className="ptn-dashboard-welcome">
            Welcome, {user.email}
          </p>
        )}
        <div className="ptn-dashboard-grid">
          {TILES.map((tile) => (
            <div
              key={tile.title}
              className="ptn-dashboard-tile"
              onClick={() => navigate(tile.path, { state: { user } })}
            >
              <span className="ptn-dashboard-tile-link">&#8599;</span>
              <span className="ptn-dashboard-tile-icon">{tile.icon}</span>
              <h3 className="ptn-dashboard-tile-title">{tile.title}</h3>
              <p className="ptn-dashboard-tile-desc">{tile.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default PartnerDashboard;
